module.exports = __webpack_public_path__ + "img/digital-disruptors-bg.ba0a7301.png";